import { InfoBox } from "@/components/common/InfoBox";
import { useDiaryByIdQuery } from "@/features/diaries/api";
import MissingDiaryDetailsCall from "@/features/diaries/components/MissingDiaryDetailsCall";
import FormsToDo from "@/features/diaries/features/new/FormsToDo";
import { useFormsToDo } from "@/features/diaries/features/new/hooks/useFormsToDo";
import NoActiveTrackerButton from "@/features/trackers/components/NoActiveTrackerButton";
import { hooks as h } from "@/hooks";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardCheck, ClipboardEdit } from "lucide-react";

const NewEntry = () => {
	const { diaryId } = Route.useParams();
	const { data: diary } = useDiaryByIdQuery(diaryId);

	h.useNav([
		{ label: "Diaries", route: { to: "/diaries" } },
		{
			route: { to: "/diaries/$diaryId/home/new" },
			label: "New",
			options: [
				{ route: { to: "/diaries/$diaryId/home/new" }, label: "New" },
				{ route: { to: "/diaries/$diaryId/home/history" }, label: "History" },
				{ route: { to: "/diaries/$diaryId/home/charts" }, label: "Charts" },
			],
		},
	]);

	if (!diary) {
		return null;
	}

	return (
		<>
			<NoActiveTrackerButton
				trackers={diary?.trackers_view}
				diaryId={diaryId}
				trackerTemplates={[]}
			/>
			<MissingDiaryDetailsCall className="mb-4" diary={diary} />

			<FormsToDo
				observations={diary?.observations_view}
				trackers={diary?.trackers_view}
			/>
		</>
	);
};

export default NewEntry;

export const Route = createFileRoute("/_app/diaries/$diaryId/home/new")({
	component: NewEntry,
});
